import styled from "styled-components";

import { Dialog, InputBase } from "@material-ui/core";
import { COLORS, responsive } from "Styles/Constants";

const MODAL_WIDTH = 600;

export const DialogWrapper = styled(Dialog)`
	.MuiBackdrop-root {
		background-color: rgba(0, 0, 0, 0.8);
	}

	.MuiDialog-paper {
		background: transparent;
		color: #fff;
		overflow: visible;
	}

	.confetti {
		width: 100%;
		height: 100%;
		position: fixed !important;
	}

	.box {
		min-width: ${MODAL_WIDTH}px;

		.inner-box {
			justify-content: center;
			align-items: center;
			display: flex;
			min-height: 400px;
			&::before {
				z-index: 1;
			}
		}

		.content {
			padding: 30px;
			.question-wrapper {
				margin-bottom: 30px;

				.question {
					font-size: 25px;
				}

				.points {
					border-radius: 3px;
					height: 20px;
					background: #1688fd;
					font-size: 17px;
					padding: 0 10px;
					width: max-content;
					margin: 0 0 0 auto;
				}
			}

			.options-wrapper {
				width: 85%;
				margin: 0 auto;

				.option-hint {
					opacity: 0.5;
				}

				.radio-group {
					flex-direction: row;
				}

				.checkbox,
				.radio {
					width: 100%;
					margin-right: 0;

					.icon {
						color: ${COLORS.SECONDARY};
					}
					.MuiFormControlLabel-label {
						font-size: 20px;
						text-align: left;
						word-break: break-all;
					}
				}

				.radio {
					.icon {
					}
				}
			}
		}

		.progress-container {
			flex-direction: column;
			.result {
				.text {
					font-size: 18px;
					margin-bottom: 0;
				}
				.sub-text {
					margin: 0;
				}
			}
		}

		.wrapped-up-container {
			display: flex;
			position: relative;
			align-items: center;
			flex-direction: column;
			padding: 5%;

			.result-text {
				font-size: 40px;
				margin-top: 20px;

				${responsive.DISPLAY`
                    font-size: 36px;
                `}

				${responsive.DESKTOP`
                    font-size: 30px;
                    margin-top: 15px;
                `}

                &.lose {
					color: red;
				}
			}

			.title {
				color: #fff;
				font-size: 28px;
				margin-top: 30px;

				${responsive.DISPLAY`
                    font-size: 24px;
                `}

				${responsive.DESKTOP`
                    font-size: 18px;
                    margin-top: 20px;
                `}
			}

			.score-container {
				gap: 50px;
				display: flex;
				margin-top: 40px;
				flex-wrap: nowrap;
				align-items: center;

				${responsive.DISPLAY`
                    margin-top: 36px;
                `}

				${responsive.DESKTOP`
                    font-size: 18px;
                `}

                .score {
					width: 110px;
					height: 110px;
					display: flex;
					align-items: center;
					flex-direction: column;
					justify-content: center;
					border: 3px solid #42defb;

					${responsive.DISPLAY`
                        width: 90px;
                        height: 90px;
                    `}

					${responsive.DESKTOP`
                        width: 70px;
                        height: 70px;
                    `}

                    .score-text {
						font-size: 36px;

						${responsive.DISPLAY`
                            font-size: 36px;
                        `}

						${responsive.DESKTOP`
                            font-size: 18px;
                        `}

                        &.correct {
							color: #06c91d;
						}

						&.incorrect {
							color: #ff0e02;
						}
					}

					.status-text {
						font-size: 14px;
						font-weight: bold;
						letter-spacing: 0.64px;

						${responsive.DISPLAY`
                            font-size: 11px;
                        `}

						${responsive.DESKTOP`
                            font-size: 7px;
                        `}
					}
				}

				.vs-text {
					font-size: 22px;

					${responsive.DISPLAY`
                        font-size: 18px;
                    `}

					${responsive.DESKTOP`
                        font-size: 14px;
                    `}
				}
			}
			.text {
				width: 90%;
				margin-top: 30px;
			}

			.attempt-container {
				width: 250px;
				height: 70px;
				display: flex;
				margin-top: 40px;
				margin-bottom: 25px;
				align-items: center;
				flex-direction: column;
				justify-content: center;
				border: 3px solid #42defb;

				.you-win-text {
					color: #67e600;
					font-size: 14px;

					${responsive.DESKTOP`
                        font-size: 12px;
                    `}
				}

				.score-text {
					font-size: 24px;
					font-weight: bold;

					${responsive.DESKTOP`
                        font-size: 22px;
                    `}
				}

				.try-again-text {
					color: red;

					${responsive.DESKTOP`
                        font-size: 10px;
                    `}
				}

				.click {
					color: #fff;
					cursor: pointer;
					font-size: 18px;
					font-weight: bold;

					${responsive.DESKTOP`
						font-size: 14px;
					`}
				}
			}

			.home-btn-image {
				left: 75px;
				width: 50px;
				bottom: 70px;
				cursor: pointer;
				position: absolute;
			}

			.replay-btn-image-container {
				display: flex;
				cursor: pointer;
				margin-top: 20px;
				padding: 5px 10px;
				border-radius: 35px;
				align-items: center;
				margin-bottom: -55px;
				justify-content: center;
				background-color: #01001c;
				border: 3px solid #42defb;

				${responsive.DESKTOP`
                    margin-bottom: -45px;
                `}

				.replay-btn-image {
					min-width: 195px;
					min-height: 50px;
					position: relative;

					${responsive.DISPLAY`
                        min-width: 175px;
                        min-height: 40px;
                    `}

					${responsive.DESKTOP`
                        min-width: 155px;
                        min-height: 30px;

                        span {
                            font-size: 12px;
                        }
                    `}
				}
			}
		}

		.result-container {
			flex-direction: column;
			width: 100%;

			.text {
				font-size: 14px;
				margin-top: 10px;
				cursor: pointer;
				transition: 0.3s;

				&.dash {
					opacity: 0.7;
					&:hover {
						opacity: 0.9;
					}
				}
			}

			.title {
				font-size: 32px;

				&.correct {
					color: ${COLORS.GREEN};
				}
				&.incorrect {
					color: ${COLORS.DANGER};
				}
			}

			.sub-title {
				margin: 15px 0;
				width: 100%;
				display: flex;
				justify-content: space-evenly;
				.correct {
					display: flex;
					flex-direction: column;
					justify-content: center;
					.text {
						font-size: 25px;
					}
					.number {
						color: ${COLORS.GREEN};
						font-size: 30px;
					}
				}
				.in-correct {
					display: flex;
					flex-direction: column;
					justify-content: center;
					.text {
						font-size: 25px;
					}
					.number {
						color: ${COLORS.DANGER};
						font-size: 30px;
					}
				}
			}

			.score-wrapper {
				margin-top: 35px;

				.text {
					color: rgba(255, 255, 255, 0.7);
				}
				.score {
					font-size: 35px;
				}
			}
		}
	}

	.button-wrapper {
		position: absolute;
		bottom: -22px;
		text-align: center;

		.btn {
			min-width: 175px;
		}
	}
`;

export const DraggingOption = styled.div`
	border-radius: 5px;
	background: rgba(66, 222, 251, 0.1);
	cursor: pointer;
	padding: 10px;
	margin: 10px 0;
	user-select: none;
	border: 1px dashed transparent;

	.is-dragging & {
		opacity: 0.5;
		border-color: ${COLORS.SECONDARY};
	}
`;

export const DarkInputBase = styled(InputBase)`
	background-color: #000017;
	border-radius: 5px;
	color: ${COLORS.SECONDARY};
	padding: 7px 20px 5px;

	input::placeholder {
		color: #fff;
	}
`;

export const Input = styled(DarkInputBase)`
	border: 3px solid rgba(66, 222, 251, 0.2);
`;
